const AdminPanelLogoPart1 = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 57 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.34746 0H4.01059L0 10H1.4854L2.48468 7.40242L2.52519 7.30821L2.9438 6.15074L2.99782 6.01615L4.67227 1.65545L6.36023 6.01615L6.41425 6.15074L6.83286 7.30821L6.85987 7.38896L7.87264 10H9.34454L5.34746 0Z"
      fill="currentColor"
    />
    <path
      d="M12.9338 10V0H16.0937C17.0525 0 17.9302 0.201884 18.7134 0.578735C19.4966 0.969044 20.1313 1.53432 20.5904 2.28802C21.0495 3.04172 21.2926 3.94347 21.2926 4.99327C21.2926 6.04307 21.063 6.94482 20.5904 7.69852C20.1313 8.45222 19.4966 9.0175 18.7134 9.40781C17.9302 9.79812 17.0525 10 16.0937 10H12.9338ZM15.8776 8.84253C16.5933 8.84253 17.2415 8.70794 17.8357 8.45222C18.4298 8.1965 18.916 7.76581 19.2806 7.20054C19.6452 6.63526 19.8342 5.89502 19.8342 5.00673C19.8342 4.11844 19.6452 3.39166 19.2806 2.81292C18.916 2.23419 18.4298 1.81696 17.8357 1.56124C17.2415 1.30552 16.5933 1.17093 15.8776 1.17093H14.3382V8.85599H15.8776V8.84253Z"
      fill="currentColor"
    />
    <path
      d="M26.2655 10V0H27.94L31.0863 7.10633L34.2327 0H35.8801V10H34.4892V2.47645L31.5589 9.08479H30.6002L27.6834 2.47645V10H26.2655Z"
      fill="currentColor"
    />
    <path d="M42.6594 10H41.255V0H42.6594V10Z" fill="currentColor" />
    <path
      d="M47.897 10V0H49.4634L54.6218 7.88695V0H56.0127V10H54.4463L49.3149 2.13997V10H47.897Z"
      fill="currentColor"
    />
  </svg>
)

const AdminPanelLogoPart2 = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 54 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.341 0H13.0042L8.9936 9.97775H10.479L11.4783 7.38595L11.5188 7.29195L11.9374 6.13706L11.9914 6.00277L13.6659 1.65177L15.3538 6.00277L15.4078 6.13706L15.8265 7.29195L15.8535 7.37253L16.8662 9.97775H18.3381L14.341 0Z"
      fill="currentColor"
    />
    <path
      d="M0 9.97775V8.18951e-07H3.98359C5.05038 8.18951e-07 5.8876 0.255152 6.46826 0.765454C7.06242 1.27576 7.346 1.96064 7.346 2.83352C7.346 3.70641 7.04892 4.41814 6.46826 4.91502C5.8876 5.41189 5.05038 5.68047 3.98359 5.68047H1.40438V9.96433H0V9.97775ZM3.97008 4.52558C4.63176 4.52558 5.11789 4.37786 5.42848 4.08242C5.73906 3.78698 5.90111 3.37068 5.90111 2.83352C5.90111 2.29636 5.73906 1.90692 5.42848 1.59805C5.11789 1.28919 4.63176 1.1549 3.97008 1.1549H1.40438V4.53901H3.97008V4.52558Z"
      fill="currentColor"
    />
    <path
      d="M21.9936 9.97775V0H23.56L28.7184 7.8694V0H30.1093V9.97775H28.5429L23.4115 2.13521V9.97775H21.9936Z"
      fill="currentColor"
    />
    <path
      d="M41.7454 9.97775H34.9936V0H41.5834V1.15489H36.398V4.09585H40.6111V5.23731H36.398V8.82286H41.7454V9.97775Z"
      fill="currentColor"
    />
    <path
      d="M53.5429 9.97775H46.9936V0H48.398V8.82286H53.5294V9.97775H53.5429Z"
      fill="currentColor"
    />
  </svg>
)

export const AdminPanelLogo = ({
  className,
  height = 12,
}: {
  className?: string
  height?: number
}) => (
  <div
    css={theme => ({
      display: 'flex',
      justifyContent: 'center',
      gap: `${theme.space.Space3} ${height}px`,
      flexWrap: 'wrap',
    })}
    className={className}
  >
    <AdminPanelLogoPart1 css={{ maxHeight: height }} />
    <AdminPanelLogoPart2 css={{ maxHeight: height }} />
  </div>
)
